__turbopack_context__.v({
  "badge": "UrgencySignalBadge-module-scss-module__aHQ7jW__badge",
});
